import Icon from '../components/Icon.vue'

Icon.register({
  'align-center': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M352 44V84C352 92.8 344.8 100 336 100H112C103.2 100 96 92.8 96 84V44C96 35.2 103.2 28 112 28H336C344.8 28 352 35.2 352 44zM16 228H432C440.8 228 448 220.8 448 212V172C448 163.2 440.8 156 432 156H16C7.2 156 0 163.2 0 172V212C0 220.8 7.2 228 16 228zM16 484H432C440.8 484 448 476.8 448 468V428C448 419.2 440.8 412 432 412H16C7.2 412 0 419.2 0 428V468C0 476.8 7.2 484 16 484zM336 284H112C103.2 284 96 291.2 96 300V340C96 348.8 103.2 356 112 356H336C344.8 356 352 348.8 352 340V300C352 291.2 344.8 284 336 284z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/align-center.js
// module id = 9l/l
// module chunks = 144